<template>
    <div class="row">        
        <div class="col-10">
            <div class="pb-2">
                <label
                    for=""
                    class="font-14 my-2"
                >
                    Margem interna

                    <span
                        class="ml-2"
                        v-b-tooltip.hover
                        data-toggle="tooltip"
                        data-placement="top"
                        title="
                            T = Topo,
                            D = Direita,
                            B = Baixo,
                            E = Esquerda
                        "
                    >
                        <i class="fas fa-info-circle"></i>
                    </span>
                </label>

                <div class="row d-flex align-itens-center">
                    <div class="col-6 d-flex align-items-center">
                        <span>T</span>

                        <input
                            @input="validatePaddingInputDesktop('top')"
                            v-model="padding.top"
                            class="ml-3 form-control"
                            type="number"
                            min="0"
                            max="9999"
                            id="padding_top"
                        >
                    </div>

                    <div class="col-6 d-flex align-items-center">
                        <span>D</span>

                        <input
                            @input="validatePaddingInputDesktop('right')"
                            v-model="padding.right"
                            class="ml-3 form-control"
                            type="number"
                            min="0"
                            max="9999"
                            id="padding_right"
                        >
                    </div>

                    <div class="col-6 mt-3 d-flex align-items-center">
                        <span>B</span>

                        <input
                            @input="validatePaddingInputDesktop('bottom')"
                            v-model="padding.bottom"
                            class="ml-3 form-control"
                            type="number"
                            min="0"
                            max="9999"
                            id="padding_bottom"
                        >
                    </div>

                    <div class="col-6 mt-3 d-flex align-items-center">
                        <span>E</span>
                        
                        <input
                            @input="validatePaddingInputDesktop('left')"
                            v-model="padding.left"
                            class="ml-3 form-control"
                            type="number"
                            min="0"
                            max="9999"
                            id="padding_left"
                        >
                    </div>
                </div>
            </div>

            <div>
                <label
                    for=""
                    class="font-14 my-2"
                >
                    Margem interna no celular

                    <span
                        class="ml-2"
                        v-b-tooltip.hover
                        data-toggle="tooltip"
                        data-placement="top"
                        title="
                            T = Topo,
                            D = Direita,
                            B = Baixo,
                            E = Esquerda
                        "
                    >
                        <i class="fas fa-info-circle"></i>
                    </span>
                </label>

                <div class="row d-flex align-itens-center">
                    <div class="col-6 d-flex align-items-center">
                        <span>T</span>

                        <input
                            @input="validatePaddingInputMobile('top')"
                            v-model="paddingMobile.top"
                            :disabled="isLockPaddingMobile"
                            class="ml-3 form-control"
                            type="number"
                            min="0"
                            max="9999"
                            id="padding_top"
                        >
                    </div>

                    <div class="col-6 d-flex align-items-center">
                        <span>D</span>

                        <input
                            @input="validatePaddingInputMobile('right')"
                            v-model="paddingMobile.right"
                            :disabled="isLockPaddingMobile"
                            class="ml-3 form-control"
                            type="number"
                            min="0"
                            max="9999"
                            id="padding_right"
                        >
                    </div>

                    <div class="col-6 mt-3 d-flex align-items-center">
                        <span>B</span>

                        <input
                            @input="validatePaddingInputMobile('bottom')"
                            v-model="paddingMobile.bottom"
                            :disabled="isLockPaddingMobile"
                            class="ml-3 form-control"
                            type="number"
                            min="0"
                            max="9999"
                            id="padding_bottom"
                        >
                    </div>

                    <div class="col-6 mt-3 d-flex align-items-center">
                        <span>E</span>

                        <input
                            @input="validatePaddingInputMobile('left')"
                            v-model="paddingMobile.left"
                            :disabled="isLockPaddingMobile"
                            class="ml-3 form-control"
                            type="number"
                            min="0"
                            max="9999"
                            id="padding_left"
                        >
                    </div>
                </div>
            </div>
        </div>

        <div class="col-2 d-flex justify-content-center align-items-center">
            <button id="deslock" v-if="isLockPaddingMobile" @click="handlerUnlockPaddingMobile">
                <i class="fal fa-lock font-14"></i>
            </button>

            <button id="lock" v-else @click="handlerLockPaddingMobile">
                <i class="fal fa-lock-open font-14"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingFramePadding',
    data() {
        return {
            padding: {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            },
            paddingMobile: {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            },
            isLockPaddingMobile: true,
        }
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    watch: {
        padding: {
            handler() {
                this.$emit('onChangePadding', this.padding);

                if (this.isLockPaddingMobile) {
                    this.paddingMobile.left = this.padding.left / 4;
                    this.paddingMobile.top = this.padding.top / 4;
                    this.paddingMobile.right = this.padding.right / 4;
                    this.paddingMobile.bottom = this.padding.bottom / 4;
                }

                this.$emit('onChangePaddingMobile', this.paddingMobile);
            },
            deep: true
        },
        paddingMobile: {
            handler() {
                this.$emit('onChangePaddingMobile', this.paddingMobile);
            },
            deep: true
        }
    },
    methods: {
        handlerUnlockPaddingMobile() {
            this.isLockPaddingMobile = false;

            this.$emit('onChangeLockPaddingMobile', this.isLockPaddingMobile);
        },
        handlerLockPaddingMobile() {
            this.isLockPaddingMobile = true;

            this.$emit('onChangeLockPaddingMobile', this.isLockPaddingMobile);
        },
        validatePaddingInputDesktop(position) {
            let paddingValue;

            switch (position) {
                case 'top':
                    paddingValue = this.padding.top;
                    break;
                case 'right':
                    paddingValue = this.padding.right;
                    break;
                case 'bottom':
                    paddingValue = this.padding.bottom;
                    break;
                case 'left':
                    paddingValue = this.padding.left;
                    break;
                default:
                    break;
            }


            if (paddingValue == null) {
                paddingValue = 0;
            }

            if (paddingValue > 9999) {
                paddingValue = 9999;
            }

            if (paddingValue < 0) {
                paddingValue = 0;
            }

            switch (position) {
                case 'top':
                    this.padding.top = paddingValue;
                    break;
                case 'right':
                    this.padding.right = paddingValue;
                    break;
                case 'bottom':
                    this.padding.bottom = paddingValue;
                    break;
                case 'left':
                    this.padding.left = paddingValue;
                    break;
                default:
                    break;
            }
        },
        validatePaddingInputMobile(position) {
            let paddingValue;

            switch (position) {
                case 'top':
                    paddingValue = this.paddingMobile.top;
                    break;
                case 'right':
                    paddingValue = this.paddingMobile.right;
                    break;
                case 'bottom':
                    paddingValue = this.paddingMobile.bottom;
                    break;
                case 'left':
                    paddingValue = this.paddingMobile.left;
                    break;
                default:
                    break;
            }

            if (paddingValue == null) {
                paddingValue = 0;
            }

            if (paddingValue > 9999) {
                paddingValue = 9999;
            }

            if (paddingValue < 0) {
                paddingValue = 0;
            }

            switch (position) {
                case 'top':
                    this.paddingMobile.top = paddingValue;
                    break;
                case 'right':
                    this.paddingMobile.right = paddingValue;
                    break;
                case 'bottom':
                    this.paddingMobile.bottom = paddingValue;
                    break;
                case 'left':
                    this.paddingMobile.left = paddingValue;
                    break;
                default:
                    break;
            }
        },
    },
    created() {
        if (this.item.extra.padding != undefined) {
            this.padding.left = this.item.extra.padding.left != null ? this.item.extra.padding.left : 0;
            this.padding.top = this.item.extra.padding.top != null ? this.item.extra.padding.top : 0;
            this.padding.right = this.item.extra.padding.right != null ? this.item.extra.padding.right : 0;
            this.padding.bottom = this.item.extra.padding.bottom != null ? this.item.extra.padding.bottom : 0;
        }

        if (this.item.extra.padding_mobile != undefined) {
            this.paddingMobile.left = this.item.extra.padding_mobile.left != null ? this.item.extra.padding_mobile.left : 0;
            this.paddingMobile.top = this.item.extra.padding_mobile.top != null ? this.item.extra.padding_mobile.top : 0;
            this.paddingMobile.right = this.item.extra.padding_mobile.right != null ? this.item.extra.padding_mobile.right : 0;
            this.paddingMobile.bottom = this.item.extra.padding_mobile.bottom != null ? this.item.extra.padding_mobile.bottom : 0;
        }

        if (this.item.extra.padding_mobile_lock != undefined) {
            this.isLockPaddingMobile = this.item.extra.padding_mobile_lock;
        }
    }
}
</script>

<style scoped>
#deslock, #lock {
    background: transparent;
    border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFramePadding.vue